(function () {
  function moveUpsell() {
    var buttons = document.querySelector('.product-form__buttons');
    var upsell = document.querySelector('[id^="upsell-"]');
    if (!buttons || !upsell) return false;
    if (buttons.nextElementSibling === upsell) return true;
    buttons.insertAdjacentElement('afterend', upsell);
    return true;
  }

  if (moveUpsell()) return;

  var observer = new MutationObserver(function () {
    if (moveUpsell()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
